import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ViewSummaryByLocation from './sidebar/ViewSummaryByLocation';
import ViewSummaryByDriver from './sidebar/ViewSummaryByDriver';
import ViewSummaryByDestination from './sidebar/ViewSummaryByDestination';
import ViewSummaryByDate from './sidebar/ViewSummaryByDate';
import ViewLoadsDetailsByDriver from './cards-panel/ViewLoadsDetailsByDriver';
import ViewLoadsDetailsByLocation from './cards-panel/ViewLoadsDetailsByLocation';
import ViewLoadsDetailsByDestination from './cards-panel/ViewLoadsDetailsByDestination';
import ViewLoadsDetailsByDate from './cards-panel/ViewLoadsDetailsByDate';
import CreateLoadWizard from './create-load-wizard/CreateLoadWizard';
import DuplicateLoadWizard from './duplicate-load-wizard/DuplicateLoadWizard';
import EditLoadWizard from './edit-load-wizard/EditLoadWizard';
import ViewLoadDrawer from './view-load-drawer/ViewLoadDrawer';
import DeleteDialog from './cards-panel/DeleteDialog';
import {
  useAddLoadToFavoritesMutation,
  useRemoveLoadFromFavoritesMutation,
} from './loadsEndpoints';
import { usePrefetch } from '../dispatchingApi';

const Loads = () => {
  const { viewBy } = useParams();

  const [createLoad, setCreateLoad] = useState();
  const [deleteLoad, setDeleteLoad] = useState();
  const [duplicateLoad, setDuplicateLoad] = useState();
  const [editLoad, setEditLoad] = useState();
  const [viewLoad, setViewLoad] = useState();

  const prefetchDestinationSummary = usePrefetch('viewLoadsSummaryByDestination');
  const prefetchDriverSummary = usePrefetch('viewLoadsSummaryByDriver');
  const prefetchDateSummary = usePrefetch('viewLoadsSummaryByDate');

  const [addToFavorites] = useAddLoadToFavoritesMutation();
  const [removeFromFavorites] = useRemoveLoadFromFavoritesMutation();

  const handleOpenCreate = setCreateLoad;
  const handleCloseCreate = () => setCreateLoad(undefined);

  const handleOpenDelete = setDeleteLoad;
  const handleCloseDelete = () => setDeleteLoad(undefined);

  const handleOpenEdit = setEditLoad;
  const handleCloseEdit = () => setEditLoad(undefined);

  const handleOpenView = setViewLoad;
  const handleCloseView = () => setViewLoad(undefined);

  const handleDelete = id => {
    handleCloseView();
    handleOpenDelete(id);
  };

  const handleDuplicate = id => {
    handleCloseView();
    setDuplicateLoad(id);
  };

  const handleEdit = id => {
    handleCloseView();
    handleOpenEdit(id);
  };
  const handleCloseDuplicate = () => setDuplicateLoad(undefined);

  const cardsPanelProps = {
    onCreate: handleOpenCreate,
    onDelete: handleDelete,
    onDuplicate: handleDuplicate,
    onEdit: handleEdit,
    onFavorite: addToFavorites,
    onUnfavorite: removeFromFavorites,
    onView: handleOpenView,
  };

  // prettier-ignore
  const sidebar = viewBy === 'destination'
    ? <ViewSummaryByDestination />
    : viewBy === 'driver'
    ? <ViewSummaryByDriver />
    : viewBy === 'date'
    ? <ViewSummaryByDate />
    : <ViewSummaryByLocation/>

  // prettier-ignore
  const cardsPanel = viewBy === 'destination'
    ? <ViewLoadsDetailsByDestination {...cardsPanelProps} />
    : viewBy === 'driver'
    ? <ViewLoadsDetailsByDriver {...cardsPanelProps} />
    : viewBy === 'date'
    ? <ViewLoadsDetailsByDate {...cardsPanelProps} />
    : <ViewLoadsDetailsByLocation {...cardsPanelProps} />

  useEffect(() => {
    prefetchDateSummary();
    prefetchDriverSummary();
    prefetchDestinationSummary();
  }, [prefetchDriverSummary, prefetchDestinationSummary, prefetchDateSummary]);

  return (
    <>
      {sidebar}
      {cardsPanel}
      {createLoad && <CreateLoadWizard onClose={handleCloseCreate} />}
      {duplicateLoad && (
        <DuplicateLoadWizard loadId={duplicateLoad} onClose={handleCloseDuplicate} />
      )}
      {editLoad && <EditLoadWizard loadId={editLoad} onClose={handleCloseEdit} />}
      {viewLoad && (
        <ViewLoadDrawer
          loadId={viewLoad}
          onClose={handleCloseView}
          onCloseDialog={handleCloseView}
          onDelete={handleDelete}
          onDuplicate={handleDuplicate}
          onEdit={handleEdit}
        />
      )}
      {deleteLoad && (
        <DeleteDialog
          driver={deleteLoad.driver}
          load={deleteLoad.load}
          onCloseDialog={handleCloseDelete}
        />
      )}
    </>
  );
};

export default Loads;
